'use strict';

var trackingUtils = require('../utils/tracking.utils');

function hide($e) {
    $e.addClass('odf-hidden');
}

function show($e) {
    $e.removeClass('odf-hidden');
}

module.exports = Odigeo.View.extend({
    selectors: {
        waiting: '.post_booking_waiting',
        bookingNotFound: '.post_booking_booking_not_found',
        phoneNumber: '.post_booking_bags_confirmation_contact_phone_number',
        notFoundBack: '.post_booking_ancillaries_back',
        headerBack: '.post_booking_bags_header_back',
        translations: '.post_booking_translations',
    },
    events: {
        'tap @phoneNumber': 'onTapPhoneNumber',
        'tap @notFoundBack': 'onTapNotFoundBack',
        'tap @headerBack': 'onTapNotFoundBack',
    },
    tmpls: {
        notFoundTemplate: '#post_booking_generic_message_template',
    },
    init: function() {
        this.tmpls = Odigeo.Utils.getTemplates(this.$el, this.tmpls);
        this.translations = Odigeo.Utils.parseJson(this.$cachedSelectors.translations.html());
    },

    showBookingNotFound: function() {
        this.renderFailureContent();
        show(this.$cachedSelectors.bookingNotFound);
        hide(this.$cachedSelectors.waiting);
        trackingUtils.trackEventWithCategory('my_area_trips_details', 'baggage_offline_no-possible', 'baggage_offline_no-possible_appearances');
    },
    onTapPhoneNumber: function() {
        trackingUtils.trackEventWithCategory('my_area_trips_details', 'baggage_offline_no-available', 'baggage_offline_no-available_call');
    },
    onTapNotFoundBack: function() {
        Odigeo.Utils.goToApplicationHome();
    },

    renderFailureContent: function() {
        var content = this.renderNotFound();
        this.$el.find(this.selectors.bookingNotFound).html(content);
    },

    renderNotFound: function() {
        return this.tmpls.notFoundTemplate({
            imageClass: 'odf-icon-svg odf-icon-svg-s odf-support-warning',
            title: this.translations.notFoundTitle,
            subtitle: this.translations.notFoundDescription,
            buttonLabel: this.translations.notFoundButtonClose,
        });
    },
});

